var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodBeveragePi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.459 6.49365H6.70898V9.09828H20.459V6.49365Z",
    fill: "#DCAB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9707 5.21246H8.19804L9.44804 2.60783H13.7216L14.3461 0.0458984H17.9594V1.32686H15.3227L15.0098 2.60783H17.7207L18.9707 5.21246Z",
    fill: "#DCAB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.458984 19.9862V19.3457H11.709V19.9862C11.709 21.0474 10.8695 21.9076 9.83398 21.9076H2.33398C1.29844 21.9076 0.458984 21.0474 0.458984 19.9862Z",
    fill: "#DCAB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.459 16.7842H1.70898V18.0651H10.459V16.7842Z",
    fill: "#DCAB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.458984 14.2216C0.458984 12.8066 1.57828 11.6597 2.95898 11.6597H9.20898C10.5897 11.6597 11.709 12.8066 11.709 14.2216V15.5026H0.458984V14.2216Z",
    fill: "#DCAB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20875 10.3789H19.0244L17.8995 21.9076H12.3178C12.7144 21.3707 12.9587 20.7098 12.9587 19.9861V18.0647H11.7087V16.7837H12.9587V14.2218C12.9587 12.1027 11.2766 10.3789 9.20875 10.3789Z",
    fill: "#DCAB00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodBeveragePi);
export default __webpack_public_path__ + "static/media/Food&BeveragePi.64e07a116c7a58c748fb20f8c43535b0.svg";
export { ForwardRef as ReactComponent };